import Store from "@/store";
import clear_all_videos from "@/router/modules/methods/clear_all_videos";

export default {
    path: '/add-content',
    name: 'Add-Content',
    component: () => import('@/views/add_content/index.vue'),
    meta: {
        title: 'Добавление контента',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {
        await clear_all_videos()
        if(Store.getters['entry_video/entry'].length === 0) {
            next({name: 'Theme'})
        } else {
            next()
        }
    }
}